'use strict';

/* globals define, config, $, ajaxify */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/memoryGame/game-analytics', [
	config.relative_path + '/plugins/nodebb-plugin-memory-game/static/vendor/chartjs/Chart.min.js',
	'translator',
], function (Chart, translator) {
	var	GameAnalytics = {};

	GameAnalytics.init = function () {
		createChart();
	};

	function createChart() {
		createMovesCountChart('#levelEasyMovesCountChart', ajaxify.data.analytics.levelEasyMovesCount);
		createMovesCountChart('#levelMediumMovesCountChart', ajaxify.data.analytics.levelMediumMovesCount);
		createMovesCountChart('#levelHardMovesCountChart', ajaxify.data.analytics.levelHardMovesCount);

		createElapsedChart('#levelEasyElapsedChart', ajaxify.data.analytics.levelEasyElapsed);
		createElapsedChart('#levelMediumElapsedChart', ajaxify.data.analytics.levelMediumElapsed);
		createElapsedChart('#levelHardElapsedChart', ajaxify.data.analytics.levelHardElapsed);
	}

	function createMovesCountChart(id, data) {
		new Chart($(id), {
			type: 'bar',
			data: {
				labels: data.map((n, i) => i + 1),
				datasets: [
					{
						data: data,
						label: 'Number of moves to finish game',
						borderColor: 'rgb(49, 120, 66)',
						backgroundColor: 'rgb(49, 120, 66)',
						fill: false,
						type: 'line',
					},
					{
						data: data,
						label: 'Number of moves to finish game',
						borderColor: 'rgb(82, 78, 183)',
						backgroundColor: 'rgb(82, 78, 183, 0.5)',
					},
				],
			},
			options: {
				scales: {
					y: {
						beginAtZero: true,
					},
				},
			},
		});
	}

	function createElapsedChart(id, data) {
		new Chart($(id), {
			type: 'bar',
			data: {
				labels: data.map(n => n.elapsed),
				datasets: [
					{
						data: data.map(n => n.elapsedSeconds),
						label: 'Time needed to finish game',
						borderColor: 'rgb(49, 120, 66)',
						backgroundColor: 'rgb(49, 120, 66)',
						type: 'line',
						fill: false,
					},
					{
						data: data.map(n => n.elapsedSeconds),
						label: 'Time needed to finish game',
						borderColor: 'rgb(82, 78, 183)',
						backgroundColor: 'rgb(82, 78, 183, 0.5)',
					},
				],
			},
			options: {
				scales: {
					y: {
						beginAtZero: true,
						ticks: {
							callback: function (value) {
								return new Date(1000 * value).toISOString().substr(11, 8);
							},
						},
					},
				},
			},
		});
	}

	return GameAnalytics;
});

